module.exports = __webpack_public_path__ + "img/P24-zh.1bc34bcf.png";